import gql from 'graphql-tag';

const query = gql`
  mutation saveQuestionary($id: ID!, $params: QuestionaryInput!) {
      saveQuestionary(id: $id, params: $params) 
  }
`;
export default query;
